import script from "./LearningSetupSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearningSetupSummary.vue?vue&type=script&setup=true&lang=ts"

import "./LearningSetupSummary.vue?vue&type=style&index=0&id=7fa0b321&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa0b321"]])

export default __exports__